"use strict";
// Inspirations:
// https://github.com/ethers-io/ethers.js/blob/main/src.ts/utils/errors.ts
// https://github.com/farcasterxyz/hub-monorepo/blob/main/packages/core/src/errors.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdkError = void 0;
const errorCodes = [
    'generic_error',
    'http_error',
    'already_exists',
    'entity_not_found',
    'invalid_argument',
    'data_encoding_error',
    'crypto_error',
    'signature_verification_failure',
    'access_denied',
    'insufficient_funds',
    'endpoint_call_error',
    'unknown_call_error',
    'unknown_revert_error',
];
class SdkError extends Error {
    errorCode;
    constructor(errorCode, options) {
        const message = typeof options === 'string' ? options : options?.message;
        const cause = typeof options === 'string' ? undefined : options?.cause;
        super(message, { cause });
        this.errorCode = errorCode;
        this.name = 'SdkError';
        Object.setPrototypeOf(this, SdkError.prototype);
    }
    toString() {
        return `${this.errorCode}${this.message ? ' ' + this.message : ''}`;
    }
}
exports.SdkError = SdkError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2RrLWVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Nkay1lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsZ0JBQWdCO0FBQ2hCLDBFQUEwRTtBQUMxRSxxRkFBcUY7OztBQUVyRixNQUFNLFVBQVUsR0FBRztJQUNqQixlQUFlO0lBQ2YsWUFBWTtJQUNaLGdCQUFnQjtJQUNoQixrQkFBa0I7SUFDbEIsa0JBQWtCO0lBQ2xCLHFCQUFxQjtJQUNyQixjQUFjO0lBQ2QsZ0NBQWdDO0lBQ2hDLGVBQWU7SUFDZixvQkFBb0I7SUFDcEIscUJBQXFCO0lBQ3JCLG9CQUFvQjtJQUNwQixzQkFBc0I7Q0FDZCxDQUFBO0FBTVYsTUFBYSxRQUFTLFNBQVEsS0FBSztJQUNMO0lBQTVCLFlBQTRCLFNBQXVCLEVBQUUsT0FBeUI7UUFDNUUsTUFBTSxPQUFPLEdBQUcsT0FBTyxPQUFPLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLE9BQU8sRUFBRSxPQUFPLENBQUE7UUFDeEUsTUFBTSxLQUFLLEdBQUcsT0FBTyxPQUFPLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLE9BQU8sRUFBRSxLQUFLLENBQUE7UUFFdEUsS0FBSyxDQUFDLE9BQU8sRUFBRSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUE7UUFKQyxjQUFTLEdBQVQsU0FBUyxDQUFjO1FBTWpELElBQUksQ0FBQyxJQUFJLEdBQUcsVUFBVSxDQUFBO1FBQ3RCLE1BQU0sQ0FBQyxjQUFjLENBQUMsSUFBSSxFQUFFLFFBQVEsQ0FBQyxTQUFTLENBQUMsQ0FBQTtJQUNqRCxDQUFDO0lBRUQsUUFBUTtRQUNOLE9BQU8sR0FBRyxJQUFJLENBQUMsU0FBUyxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLEdBQUcsR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQTtJQUNyRSxDQUFDO0NBQ0Y7QUFkRCw0QkFjQyJ9